// Tipos de conectores disponíveis
export const CONNECTOR_TYPES = {
  ZENDESK: "zendesk",
  // Adicionar novos tipos aqui no futuro
  // SALESFORCE: "salesforce",
  // JIRA: "jira",
  // SERVICENOW: "servicenow",
};

// Labels para exibição
export const CONNECTOR_TYPE_LABELS = {
  [CONNECTOR_TYPES.ZENDESK]: "Zendesk",
  // Adicionar labels dos novos tipos aqui
};

// Configuração dos conectores - usado para determinar qual modal/componente usar
export const CONNECTOR_CONFIG = {
  [CONNECTOR_TYPES.ZENDESK]: {
    label: CONNECTOR_TYPE_LABELS[CONNECTOR_TYPES.ZENDESK],
    icon: "fas fa-ticket-alt",
    description: "Integração com plataforma de atendimento Zendesk",
    fields: [
      "api_url",
      "api_token",
      "email",
      "subdomain",
      "tickets_api_url",
      "comments_api_url",
      "webhook_signing_key",
    ],
  },
  // Configurações para futuros conectores aqui
};

// Status dos conectores
export const CONNECTOR_STATUS = {
  ACTIVE: true,
  INACTIVE: false,
};

// Validadores para campos comuns
export const FIELD_VALIDATORS = {
  email: {
    required: "Email é obrigatório",
    pattern: {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Email inválido",
    },
  },
  url: {
    required: "URL é obrigatória",
    pattern: {
      value: /^https?:\/\/.+/,
      message: "URL deve começar com http:// ou https://",
    },
  },
  subdomain: {
    required: "Subdomínio é obrigatório",
    pattern: {
      value: /^[a-z0-9-]+$/,
      message:
        "Subdomínio deve conter apenas letras minúsculas, números e hífens",
    },
  },
  api_token: {
    required: "Token da API é obrigatório",
    minLength: {
      value: 10,
      message: "Token deve ter pelo menos 10 caracteres",
    },
  },
};

export default {
  CONNECTOR_TYPES,
  CONNECTOR_TYPE_LABELS,
  CONNECTOR_CONFIG,
  CONNECTOR_STATUS,
  FIELD_VALIDATORS,
};
